module.exports = __webpack_public_path__ + "img/grafico-em-barra.6efa42be.svg";